import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description LegalAssistance icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { LegalAssistance } from '@sravni/design-system-icons'
 *
 * <LegalAssistance />
 * ```
 */
var LegalAssistance = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "LegalAssistance", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.682 3.025v3.352M12.37 11.883h5.774M3.219 13.57h5.775M12.52 11.483c-.159.297-.225.641-.16.971a2.954 2.954 0 0 0 5.796 0 1.466 1.466 0 0 0-.162-.97L15.258 6.4l-2.737 5.083v0ZM3.366 13.171c-.16.296-.225.64-.16.97a2.955 2.955 0 0 0 5.796 0 1.465 1.465 0 0 0-.161-.97L6.104 8.087l-2.738 5.084v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.258 6.4a13.006 13.006 0 0 0-8.65 1.408l-.504.28", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { LegalAssistance };
//# sourceMappingURL=LegalAssistance.js.map
